import React from 'react'

import { UsersIcon, HelpCircleIcon } from 'components/shared/Icon/model'
import { TetherPortal } from 'components/shared/TetherPortal/TetherPortal'
import { useTooltip } from 'hooks'
import cx from 'classnames'
import { t } from 'ttag'
import styles from './CompareButton.module.scss'
import { Icon } from 'components/shared/Icon/Icon'
import { Button } from 'components/shared/Button/Button'
import { Arrow } from 'components/shared/Arrow/Arrow'
import { Box } from 'components/layout/Box/Box'

export const CompareButton = ({ isDisabled, handleClick }) => {
  const {
    state: {
      arrowRef,
      arrowStyle,
      floating,
      floatingStyle,
      reference,
      hasArrow,
      isToggled,
    },
    handlers: {
      handleBlur,
      handleFocus,
      handleMouseEnter,
      handleMouseLeave,
      handleTouchEnd,
      handleTouchStart,
    },
  } = useTooltip({ initialPlacement: 'bottom' })

  return (
    <div>
      <Button
        className={styles.button}
        color="primary"
        icon={UsersIcon}
        label={
          <div className={styles.compareLabel}>
            {t`Compare`}
            {
              <div
                className={cx(styles.icon, {
                  [styles.hide]: !isDisabled,
                })}
                {...{
                  ref: reference,
                  onBlur: handleBlur,
                  onFocus: handleFocus,
                  onMouseEnter: handleMouseEnter,
                  onMouseLeave: handleMouseLeave,
                  onTouchStart: handleTouchStart,
                  onTouchEnd: handleTouchEnd,
                }}
              >
                <Icon icon={HelpCircleIcon} size={18} />
              </div>
            }
          </div>
        }
        size="small"
        variant="filled"
        onClick={handleClick}
        isDisabled={isDisabled}
      />
      <TetherPortal isOpen={isToggled}>
        <Box
          align="center"
          className={styles.message}
          justify="center"
          ref={floating}
          // TODO(a11y): was role="status", which <Box> silently drops. Restore as
          // ariaRole once the DOM change can be verified in the UI.
          style={floatingStyle}
        >
          {hasArrow && (
            <Arrow
              ref={arrowRef}
              size="small"
              style={arrowStyle}
              theme="bright"
            />
          )}
          <Box
            align="center"
            className={styles.content}
            direction="column"
            justify="center"
            // TODO(a11y): was role="tooltip", which <Box> silently drops. Restore as
            // ariaRole once the DOM change can be verified in the UI.
          >
            <div>
              {t`Select 2 candidates in the table below in order to compare them`}
            </div>
          </Box>
        </Box>
      </TetherPortal>
    </div>
  )
}
